import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-setup-option-dialog',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
  ],
  templateUrl: './setup-option-dialog.component.html',
  styleUrl: './setup-option-dialog.component.scss',
})
export class SetupOptionDialogComponent {
  @Output() optionSelected = new EventEmitter<boolean>();
  @Output() cancel = new EventEmitter<void>();
}
